import './../home/style/home.css'
import { useEffect } from "react";
import DiscountProduct from "../../components/discountProduct/discountProduct";
import useGetData from "../../hook/getData";
import { GetProducts } from "../../services/client/products/getProducts";

const Discount = () => {
    const { data: Products } = useGetData(['products'], GetProducts)
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <>
            <section className="container more-sell py-5">
                {Products?.hasDiscountProducts?.lenght > 0 ? (
                    <div className="row justify-content-md-start justify-content-center gy-4">
                        {Products?.hasDiscountProducts?.map((product: any) => (
                            <div className="col-md-2 col-lg-2 col-8" key={product.id + 'newProduct'}>
                                <DiscountProduct product={product} price={product.price} percent_sale={product.percent_sale} slug={product.slug} has_variation={product.has_variation} sale_price={product.sale_price} name={product.name} primary_image={product.primary_image} description={product.description} quantity_check={product.quantity_check} />
                            </div>
                        ))}
                    </div>
                ) :
                    (
                        <>
                            <div className="container h-100">
                                <div className="row h-100 justify-content-center align-items-center">
                                    <div className="col-md-6 text-center">
                                        <img alt="logo" style={{ width: 60, height: 60, borderRadius: 10 }} src={require('../../assets/media/logo/final.png')} />
                                        <p className="fw-bold mt-3">
                                            آیتمی پیدا نشد
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
            </section>
        </>
    )
}

export default Discount;